import {keyMirror} from 'utils/DBUtils';

export const DateRangeFilterTypes = keyMirror({
  LiveRange: null,
  EndDate: null
});



// WEBPACK FOOTER //
// ./public/components/DateRange/utils.js